import Utils from "../../utility";

const initialState = {
  list: [],
  count: 0,
  offset: 1,
  take: 20,
  reviewBadge: 0,
  // Latest task.* socket event — pages watch this to trigger a refetch
  // without needing their own socket connection.
  liveEvent: null,
  // { [taskId]: escalationLevel } — updated directly from task.escalated so
  // any already-rendered task reflects its new level without a refetch.
  escalationByTaskId: {},
};

export const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.TASKS:
      return { ...state, ...action.payload };
    case Utils.ActionName.RESET_TASKS:
      return { ...initialState };
    case Utils.ActionName.TASKS_REVIEW_BADGE:
      return { ...state, reviewBadge: state.reviewBadge + 1 };
    case Utils.ActionName.RESET_REVIEW_BADGE:
      return { ...state, reviewBadge: 0 };
    case Utils.ActionName.TASKS_LIVE_EVENT:
      return { ...state, liveEvent: action.payload };
    case Utils.ActionName.TASKS_ESCALATION_UPDATE:
      return {
        ...state,
        escalationByTaskId: {
          ...state.escalationByTaskId,
          [action.payload.taskId]: action.payload.escalationLevel,
        },
      };
    default:
      return state;
  }
};
